const defaultState = {
	//Basic
	defaultPlant: 'HUV1',
	commCdType: '',
	commCdList: '',
	currentPage: '0',
	pageUnit: '10',

	//Main
	tableDataManagementList: [],
	tableDataPlants: [],
	tableTypes: [],
	schemas: [],
	allSchemas: [],
	tables: [],
	unmanagedTables: [],
	useYnOptions: [],
	mgtTypes: [
		{ label: '전체', value: 'N' },
		{ label: '관리만', value: 'Y' }
	],

	searchParams: {
		plantCd: 'HVS1',
		tableType: '',
		schema: '',
		tableId: '',
		managed: ''
	},

	groups: {
		currentPage: 0,
		pageUnit: 10,
		totalSize: 0,
		data: []
	},

	//Modal
	TableDataManagementModal: false,
	tableDataManagementModalValue: {
		flg: 'I',
		schema: '',
		tableId: '',
		saveDays: '',
		delCycleDay: '',
		delCycleTime: ''
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
